import { Component } from '@angular/core';

@Component({
  selector: 'app-transaction-flow',
  templateUrl: './transaction-flow.component.html',
  styleUrls: ['./transaction-flow.component.css']
})
export class TransactionFlowComponent {

}
